import { render, staticRenderFns } from "./preprime-contact-form.vue?vue&type=template&id=5ff80ce8"
import script from "./preprime-contact-form.vue?vue&type=script&lang=js"
export * from "./preprime-contact-form.vue?vue&type=script&lang=js"
import style0 from "./preprime-contact-form.vue?vue&type=style&index=0&id=5ff80ce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports